import { Record, List } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { getStatusOrder } from 'enums/team-member-status';
import TeamMember from './TeamMemberModel';

const TeamModelRecord = Record({
  id: 0,
  name: '',
  createdAt: new Date(),
  champion: null,
  default: false,
  entity: {},
  users: List(),
});

export default class TeamModel extends TeamModelRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {
      createdAt: Hydrator.timestamp2Date,
      champion: TeamMember.deserialize,
      users: Hydrator.fromList(TeamMember.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new TeamModel(hydrated);
  }

  normalize() {
    return this.merge({
      champion: this.getIn(['champion', 'id']),
      users: this.get('users', List()).map((user) => user.id),
    });
  }

  denormalize({ members }) {
    const champion = members.get(this.champion);

    return this.merge({
      champion,
      users: this.users
        .map((memberId) =>
          members
            // Replace the id with member
            .get(memberId)
            // Update his champion flag
            .set('champion', memberId === champion?.id),
        )
        .sort((memberA, memberB) => {
          if (memberA.champion) {
            return -1;
          }

          if (memberB.champion) {
            return 1;
          }

          return getStatusOrder(memberA.status) - getStatusOrder(memberB.status);
        }),
    });
  }

  get companyId() {
    return this.getIn(['entity', 'entityId']);
  }
}
